import { PlaceOutlined } from '@mui/icons-material'
import { Grid, Typography, useTheme } from '@mui/material'

import useStyles from './index.styles'

interface IProps {
  deviceLocation: string | undefined
  deviceLocationNote: string | undefined
}

const LocationCard = ({ deviceLocation, deviceLocationNote }: IProps) => {
  const theme = useTheme()
  const classes = useStyles

  if (!deviceLocation && !deviceLocationNote) return null

  return (
    <Grid container={true} size={12} sx={classes.locationCardContainer}>
      <PlaceOutlined htmlColor={theme.palette.text.secondary} />

      <Grid sx={classes.locationCardTextColumn}>
        {deviceLocation && (
          <Typography variant="body1" className="fs-exclude" sx={classes.locationCardDeviceName}>
            {deviceLocation}
          </Typography>
        )}

        {deviceLocationNote && (
          <Typography variant="body2" className="fs-exclude" color="textSecondary">
            {deviceLocationNote}
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

export default LocationCard
